import { render, staticRenderFns } from "./v-corner-button.vue?vue&type=template&id=0969d93d&scoped=true&"
import script from "./v-corner-button.vue?vue&type=script&lang=js&"
export * from "./v-corner-button.vue?vue&type=script&lang=js&"
import style0 from "./v-corner-button.vue?vue&type=style&index=0&id=0969d93d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0969d93d",
  null
  
)

export default component.exports